/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();

      console.log("FreeShipping component initialized");

      this.onMinimumChangeHandler = this.onMinimumChange.bind(this);
    }

    get minimum() {
      return parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1);
    }

    set minimum(value) {
      this.dataset.minimum = value;
      this.connectedCallback();
    }

    onMinimumChange(event) {
      // console.log('Free shipping minimum changed', event);
      if (event.detail && event.detail.threshold_number) {
        this.minimum = event.detail.threshold_number;
      }
    }

    connectedCallback() {
      document.addEventListener('shipping-zone:changed', this.onMinimumChangeHandler);

      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = this.minimum;
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}

if (!customElements.get('cart-drawer-summary')) {
  class CartDrawerSummary extends HTMLElement {
    constructor() {
      super();

      this.cartShippingSelection = this.querySelector("#cartShippingSelection");
      this.setShippingCostsHandler = this._setNewShippingCosts.bind(this);
    }

    connectedCallback() {
      this.cartShippingSelection.addEventListener("change", this.setShippingCostsHandler);
      this._init();
    }

    _init() {
      console.log("Init Shipping Costs");
      console.log(sessionStorage.getItem("country"));
      if(sessionStorage.getItem("country") != undefined) {
        var shippingCountry = this.querySelector("#cartShippingSelection");
        shippingCountry.value = sessionStorage.getItem("country");
        this._setNewShippingCosts(shippingCountry, document);
      }
    }

    _setNewShippingCosts() {
      const zone = this.cartShippingSelection;
			if (document.querySelector("#cartShippingSelection") != undefined) {
				document.querySelector("#cartShippingSelection").style.width = document.querySelector(".shippingSelect--helperElement").offsetWidth + 31 +"px" ;
			}

			let shippingSelect = document.querySelector("#cartShippingSelection");
			let selected = zone.options[zone.selectedIndex].getAttribute("value");
			let selectedThreshold = zone.options[zone.selectedIndex].getAttribute("threshold");
			let selectedCosts = zone.options[zone.selectedIndex].getAttribute("costs");

			var shippingCostsField = document.querySelector(".shipping__costs");
			var subTotal = document.querySelector("#cart__subtotal");
			var totalCosts = document.querySelector("#total__costs");
			var mediaQueries = window.matchMedia("(max-width: 460px)");

			let helperElement = document.querySelector(".shippingSelect--helperElement");
			helperElement.innerHTML = zone.options[zone.selectedIndex].getAttribute("value");
			shippingSelect.style.width = helperElement.offsetWidth + 25 + "px";

			let FreeShippingBar = document.getElementsByTagName("free-shipping-bar")[0];
			let SecondFreeShippingBar = document.querySelector(".shipping-bar-second");

			sessionStorage.setItem("country", selected);

			if(parseFloat(selectedThreshold) <= parseFloat(subTotal.innerHTML)) {
				if (mediaQueries.matches) {
					shippingCostsField.innerHTML = "0.00 €";
				} else {
					shippingCostsField.innerHTML = "Kostenloser Versand";
				}
				totalCosts.innerHTML = subTotal.innerHTML;

			} else {
				shippingCostsField.innerHTML = selectedCosts;
				const total = parseFloat(subTotal.innerHTML) + parseFloat(shippingCostsField.innerHTML);
				totalCosts.innerHTML = total.toFixed(2) + " €";
			}

			document.dispatchEvent(new CustomEvent("shipping-zone:changed", {
        bubbles: true,
        detail: {
          zone: selected,
          costs: selectedCosts,
          threshold: selectedThreshold,
          threshold_number: zone.options[zone.selectedIndex].getAttribute("threshold_number")
        }
			}));
    }
  }

  customElements.define('cart-drawer-summary', CartDrawerSummary);
}
